import { render, staticRenderFns } from "./MediaTable.vue?vue&type=template&id=23a98202&scoped=true"
import script from "./MediaTable.vue?vue&type=script&lang=js"
export * from "./MediaTable.vue?vue&type=script&lang=js"
import style0 from "./MediaTable.vue?vue&type=style&index=0&id=23a98202&prod&lang=css"
import style1 from "./MediaTable.vue?vue&type=style&index=1&id=23a98202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a98202",
  null
  
)

export default component.exports